import React, { useEffect, useState } from 'react';
import { Menu, MenuItem, IconButton, Typography, Badge, Popover, List, ListItemButton, ListItemText, Divider, Box, Button } from '@mui/material';
import { KeyboardArrowDown, NotificationsOutlined, DeleteForever, NotificationsActive, HelpOutlineOutlined, CloudDownload, FileOpen } from '@mui/icons-material';
import userNavigation from '../img/navigation-user.svg'
import { clearNotifications, clearSearch, updateFilter, updateNetwork, updateReadStatus, updateSelectedSection, useNotifications } from '../state/services';
import { useInputParamState } from '../state/Input-param-state';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import { getOnlineNetworks, useAccessToken, useClearDetails, useMode, useSetMode, useSetSelectedMarker } from '../state/application-state-service';
import { useApplicationState } from '../state/application-state';
import { newId } from '../pages/home/heat-map/GlobalFilter';
import { ToggleButton, ToggleButtonGroup} from "@mui/material";


function Profile({ name, handleLogout } : {name : string, handleLogout : () => void }) {
  const paramState = useInputParamState()
  const applicationState = useApplicationState()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const accesToken = useAccessToken()
  const navigate = useNavigate();
  const clearDetails = useClearDetails()

  const mode = useMode()
  const setMode = useSetMode()

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

   const handleChange = (mode: 'offline' | 'online') => {
    if(mode === 'online'){ 
      setMode('online')
      updateSelectedSection(paramState, [])
      getOnlineNetworks(paramState, applicationState, accesToken)
    }
    else {
      clearDetails()
    }
    updateFilter(paramState, { logic: "AND", groups: [ { id: newId(), logic: "AND", rows: [] }]})
    updateNetwork(paramState, {})
    clearSearch(paramState)
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <MapModeToggle
        mode={mode}
        onChange={(newMode) => handleChange(newMode)}
      />
      <IconButton color="inherit" onClick={() => navigate("/help")}>
        <HelpOutlineOutlined />
      </IconButton>
      <NotificationList />
      {/* Username and dropdown icon */}
      <IconButton onClick={handleClick} color="inherit">
        <img src={userNavigation} alt="close" className="navigation-user" />
        <Typography variant="body1" style={{ color: 'black' }}> 
          {name}
        </Typography>
        <KeyboardArrowDown style={{ color: 'black' }} />
      </IconButton>

      {/* Menu for options */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            marginTop: 8,
            minWidth: 180,
          },
        }}
      >
        <MenuItem onClick={handleLogout}>Log out</MenuItem>
      </Menu>
    </div>
  );
}

const NotificationList = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const notifications = useNotifications()
  const paramState = useInputParamState()
  const [isOpen, setIsOpen] = useState(false)
  const mode = useMode()
  const setSelectedMarker = useSetSelectedMarker();

  const handleClickNotify = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    updateReadStatus(paramState, true, notifications)
    updateSelectedSection(paramState, [])
  };

  const handleCloseNotify = () => {
    setAnchorEl(null);
  };

  const handleListItemClick = (id: string, coord: [number, number], name?: string) => {
    if (mode === 'offline') {
      const str = name ?? '.'
      const index = str.split(".")[1];
      const edge = str.split(".")[0];
      let values = { coordinates: [{ lat: coord[0], long: coord[1] }], railwayEdgeId: id, index: index ?? 0, edgeName: edge ?? '' }
      updateSelectedSection(paramState, values)
    }
    else setSelectedMarker(id)
    handleCloseNotify()
  }

  useEffect(() => {
    if (notifications.read === false && notifications.notifications.length > 0) {
      setIsOpen(true)
    }
  }, [notifications])

  const open = Boolean(anchorEl);
  return <>
    <IconButton onClick={handleClickNotify} color="inherit">
      <Badge color="error" badgeContent={notifications.read ? 0 : notifications.no_notifications}>
        <NotificationsOutlined />
      </Badge>
    </IconButton>
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleCloseNotify}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <List sx={{ minWidth: 250, maxWidth: 300, p: 1 }}>
          {notifications.notifications.length > 0 ? (
            <>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: 1 }}>
              <Typography variant="h6">Notifications</Typography>
              <Button
                color="error"
                size="small"
                onClick={() => clearNotifications(paramState)} // Clear all notifications
              >
                <DeleteForever />
              </Button>
            </Box>
              {notifications.notifications.slice().reverse().map((notif) => {
                let message = (
                  <>
                    {notif.message}
                    <Typography component="span" sx={{ color: "green", fontWeight: "bold" }}>
                      {notif.name}
                    </Typography>
                  </>
                );
                return <><ListItemButton onClick={() => handleListItemClick(notif.id, notif.coord, notif.name)}>
                  <ListItemText primary={message} />
                </ListItemButton>
                  <Divider /></>
              })}
            </>
          ) : (
            <Typography variant="body2" sx={{ p: 2, textAlign: "center" }}>
              No new notifications
            </Typography>
          )}
      </List>
    </Popover>
    <CustomizedSnackbars open={isOpen} setOpen={setIsOpen} />
  </>
}

const  CustomizedSnackbars = ({open, setOpen} : {open : boolean, setOpen: (value: boolean) => void}) => {

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={1800} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
          iconMapping={{
            success: <NotificationsActive fontSize="inherit" />,
          }}
        >
          You have a new notification!
        </Alert>
      </Snackbar>
    </div>
  );
}

type MapMode = "offline" | "online";

interface MapModeToggleProps {
  mode: MapMode;
  onChange: (mode: MapMode) => void;
}

export function MapModeToggle({ mode, onChange }: MapModeToggleProps) {
  return (
    <Box>
      <ToggleButtonGroup
        exclusive
        value={mode}
        onChange={(_, newMode: MapMode | null) => {
          if (newMode) {
            onChange(newMode);
          }
        }}
        aria-label="Map mode"
        sx={{
          p: "4px",
          borderRadius: "999px",
          backgroundColor: "#F1F3F1",

          "& .MuiToggleButton-root": {
            minWidth: 110,
            px: 2,
            py: 0.75,
            border: 0,
            borderRadius: "999px !important",
            color: "text.secondary",
            fontSize: "0.875rem",
            fontWeight: 600,
            textTransform: "none",
            transition: "all 0.2s ease",

            "&:hover": {
              backgroundColor: "rgba(51, 174, 51, 0.08)",
            },

            "&.Mui-selected": {
              color: "#FFFFFF",
              backgroundColor: "#33AE33",
              boxShadow: "0 2px 8px rgba(51, 174, 51, 0.3)",

              "&:hover": {
                backgroundColor: "#289428",
              },
            },
          },
        }}
      >
        <ToggleButton value="offline" sx={{ gap: 1 }}><span><FileOpen fontSize='small' /></span>Internal Networks</ToggleButton>
        <ToggleButton value="online" sx={{ gap: 1 }}><span><CloudDownload fontSize='small' /></span> External Networks</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default Profile;
